import { useContext } from 'react';
import DataContext from '../../contexts/DataContext';

import ButtonQuestion from './ButtonQuestion';
import {
  customerHomeIcons,
  enphaseCustomerIcons,
  propertyIcons,
  sunlightIcons,
  upgradeSystemIcons,
} from '../data/icons';
import { DataKey } from '../enums';
import type { Icon } from '../types';

export interface SlideOption {
  name: string;
  icon: string;
  iconHover: string;
  value: string | boolean;
}

interface SlideOptionsProps {
  dataKey: string;
  options: SlideOption[];
}

export default function SlideOptions({ dataKey, options }: SlideOptionsProps) {
  const { data } = useContext(DataContext);
  const selectedOption = data[dataKey];
  const showStackedIcons =
    dataKey === DataKey.EnphaseCustomer ||
    dataKey === DataKey.CustomerHome ||
    dataKey === DataKey.UpgradeSystem;
  const wrapIcons = dataKey === DataKey.UpgradeSystem;

  let icons: Icon[] = [];
  switch (dataKey) {
    case DataKey.EnphaseCustomer:
      icons = enphaseCustomerIcons;
      break;
    case DataKey.CustomerHome:
      icons = customerHomeIcons;
      break;
    case DataKey.UpgradeSystem:
      icons = upgradeSystemIcons;
      break;
    case DataKey.Property:
      icons = propertyIcons;
      break;
    case DataKey.Sunlight:
      icons = sunlightIcons;
      break;
    default:
      icons = propertyIcons;
  }

  return (
    <div
      className={`mt-[30px] md:mt-[60px] flex justify-between ${
        showStackedIcons ? 'flex-col' : 'flex-col md:flex-row'
      } ${wrapIcons ? 'flex-wrap md:max-h-[212px] short:max-h-none' : 'flex-nowrap'}`}>
      {options.map((option: SlideOption, index: number) => {
        const { path } = icons.find((icon) => icon.name === option.icon) || {};
        const { path: hoverPath } =
          icons.find((icon) => icon.name === option.iconHover) || {};

        return (
          <ButtonQuestion
            dataKey={dataKey}
            key={index}
            option={option}
            icon={path}
            iconHover={hoverPath}
            selected={selectedOption === option.value}
            showStackedIcons={showStackedIcons}
          />
        );
      })}
    </div>
  );
}
